module.exports = __webpack_public_path__ + "static/img/b2_body.15649bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/core/b2_body.png
// module id = 6jzu
// module chunks = 1